import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

const BatchEditUsersDirective = angularDirectiveToReact('batchEditUsers', { section: '<' });

export function BatchEditUsers() {
    useLoadAdminDependencies();

    const [key, params] = useAngularToReactRoute<{ section?: string }>();

    return <BatchEditUsersDirective key={key} {...params} />;
}
